import { Button } from "antd";
import FormHeader from "./FormHeader";
import FormInput from "../elements/FormInput";
import { useTranslation } from "react-i18next";
import { EDEX_RENEW_URL, TELEGRAM_CHANEL_URL } from "../../config";
import { useUser } from "../../contexts/UserContext";

const ProfileForm = (title) => {
    const { t } = useTranslation();
    const { user, userLoading,logoutUser } = useUser();

    return (
    <div>
        <FormHeader title={t('user.my_information')} icon={<span className="svg-icon icon-user" style={{ fontSize: 28 }}></span>}>
            <div className="time-left">
                <span>{t('user.the_time_left')}</span>
                <div className="days">
                    <span>{user.days}</span>
                    <span>{t('user.days')}</span>
                </div>
                <Button type="primary" className="extention-btn" href={EDEX_RENEW_URL} target="_blank">{t('user.renew')}</Button>
            </div>
        </FormHeader>
        <div>
            <FormInput label={t('user.license_code')} value={user.username} />
            {/* <FormInput label={t('user.email')} value="test@example.com" /> */}
            <div>
                <Button type="primary" className="logout-btn" loading={userLoading} onClick={() => {
                    logoutUser();
                }}>{t('user.logout')}</Button>
            </div>
            <Button type="primary" className="telegram-btn" href={TELEGRAM_CHANEL_URL} target="_blank" icon={<span className="svg-icon icon-telegram"></span>}>{t('user.telegram')}</Button>
        </div>
    </div>)
};


export default ProfileForm;